import { render, staticRenderFns } from "./r-plinko-exchange-config-panel.vue?vue&type=template&id=00ea2f07"
import script from "./r-plinko-exchange-config-panel.vue?vue&type=script&lang=js"
export * from "./r-plinko-exchange-config-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00ea2f07')) {
      api.createRecord('00ea2f07', component.options)
    } else {
      api.reload('00ea2f07', component.options)
    }
    module.hot.accept("./r-plinko-exchange-config-panel.vue?vue&type=template&id=00ea2f07", function () {
      api.rerender('00ea2f07', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/smart-offer/bundle-plinko/r-plinko-exchange-config-panel.vue"
export default component.exports